// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      status: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
    })
    .required();
};
